export const MOBILE = 'mobile';
export const TABLET = 'tablet';
export const DESKTOP = 'desktop';

const strategies = [
  {
    name: MOBILE,
    matcher: (width) => width <= 600,
  },
  {
    name: TABLET,
    matcher: (width) => width <= 900,
  },
  {
    name: DESKTOP,
    matcher: (width) => width >= 901,
  },
];

/**
 * Recupera a resolução baseado numa largura em píxels.
 * mobile (<=550px)
 * tablet (<=900px)
 * desktop (>=901px)
 *
 * @param {*} width
 */
export function getResolution(width) {
  const matched = strategies.find((strategy) => strategy.matcher(width));

  return matched.name;
}
